import { createSvgIcon } from "@mui/material";
import StarRateOutlinedIcon from "@mui/icons-material/StarRateOutlined";

const DashboardIcon = createSvgIcon(
  <svg
    width="28"
    height="28"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4175 5.21538C8.93439 5.04963 7.39917 5.04963 5.91608 5.21538C5.55571 5.25566 5.27151 5.54101 5.23097 5.88758C5.05387 7.40184 5.05387 8.93159 5.23097 10.4459C5.27151 10.7924 5.55571 11.0778 5.91608 11.1181C7.39917 11.2838 8.93439 11.2838 10.4175 11.1181C10.7778 11.0778 11.062 10.7924 11.1026 10.4459C11.2797 8.93159 11.2797 7.40184 11.1026 5.88758C11.062 5.54101 10.7778 5.25566 10.4175 5.21538ZM5.7217 3.47621C7.33397 3.29602 8.99958 3.29602 10.6119 3.47621C11.7678 3.60541 12.704 4.51539 12.8407 5.68429C13.0336 7.33362 13.0336 8.99982 12.8407 10.6491C12.704 11.818 11.7678 12.728 10.6119 12.8572C8.99958 13.0374 7.33397 13.0374 5.7217 12.8572C4.56572 12.728 3.62954 11.818 3.49282 10.6491C3.29992 8.99982 3.29992 7.33362 3.49282 5.68429C3.62954 4.51539 4.56572 3.60541 5.7217 3.47621Z"
      fill="#8B8E93"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4175 16.882C8.93439 16.7163 7.39917 16.7163 5.91608 16.882C5.55571 16.9223 5.27151 17.2077 5.23097 17.5542C5.05387 19.0685 5.05387 20.5983 5.23097 22.1125C5.27151 22.4591 5.55571 22.7444 5.91608 22.7847C7.39917 22.9505 8.93439 22.9505 10.4175 22.7847C10.7778 22.7444 11.062 22.4591 11.1026 22.1125C11.2797 20.5983 11.2797 19.0685 11.1026 17.5542C11.062 17.2077 10.7778 16.9223 10.4175 16.882ZM5.7217 15.1429C7.33397 14.9627 8.99958 14.9627 10.6119 15.1429C11.7678 15.2721 12.704 16.1821 12.8407 17.351C13.0336 19.0003 13.0336 20.6665 12.8407 22.3158C12.704 23.4847 11.7678 24.3947 10.6119 24.5239C8.99958 24.7041 7.33397 24.7041 5.7217 24.5239C4.56572 24.3947 3.62954 23.4847 3.49282 22.3158C3.29992 20.6665 3.29992 19.0003 3.49282 17.351C3.62954 16.1821 4.56572 15.2721 5.7217 15.1429Z"
      fill="#8B8E93"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.0841 5.21538C20.6011 5.04963 19.0658 5.04963 17.5827 5.21538C17.2224 5.25566 16.9382 5.54101 16.8976 5.88758C16.7205 7.40184 16.7205 8.93159 16.8976 10.4459C16.9382 10.7924 17.2224 11.0778 17.5827 11.1181C19.0658 11.2838 20.6011 11.2838 22.0841 11.1181C22.4445 11.0778 22.7287 10.7924 22.7692 10.4459C22.9464 8.93159 22.9464 7.40184 22.7692 5.88758C22.7287 5.54101 22.4445 5.25566 22.0841 5.21538ZM17.3884 3.47621C19.0006 3.29602 20.6663 3.29602 22.2785 3.47621C23.4345 3.60541 24.3707 4.51539 24.5074 5.68429C24.7003 7.33362 24.7003 8.99982 24.5074 10.6491C24.3707 11.818 23.4345 12.728 22.2785 12.8572C20.6663 13.0374 19.0006 13.0374 17.3884 12.8572C16.2324 12.728 15.2962 11.818 15.1595 10.6491C14.9666 8.99982 14.9666 7.33362 15.1595 5.68429C15.2962 4.51539 16.2324 3.60541 17.3884 3.47621Z"
      fill="#8B8E93"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.0841 16.882C20.6011 16.7163 19.0658 16.7163 17.5827 16.882C17.2224 16.9223 16.9382 17.2077 16.8976 17.5542C16.7205 19.0685 16.7205 20.5983 16.8976 22.1125C16.9382 22.4591 17.2224 22.7444 17.5827 22.7847C19.0658 22.9505 20.6011 22.9505 22.0841 22.7847C22.4445 22.7444 22.7287 22.4591 22.7692 22.1125C22.9464 20.5983 22.9464 19.0685 22.7692 17.5542C22.7287 17.2077 22.4445 16.9223 22.0841 16.882ZM17.3884 15.1429C19.0006 14.9627 20.6663 14.9627 22.2785 15.1429C23.4345 15.2721 24.3707 16.1821 24.5074 17.351C24.7003 19.0003 24.7003 20.6665 24.5074 22.3158C24.3707 23.4847 23.4345 24.3947 22.2785 24.5239C20.6663 24.7041 19.0006 24.7041 17.3884 24.5239C16.2324 24.3947 15.2962 23.4847 15.1595 22.3158C14.9666 20.6665 14.9666 19.0003 15.1595 17.351C15.2962 16.1821 16.2324 15.2721 17.3884 15.1429Z"
      fill="#8B8E93"
    />
  </svg>
);

const AchievementIcon = StarRateOutlinedIcon;

const GetStartedIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    viewBox="-1 0 16 16"
  >
    <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
  </svg>
);

const AccountAnalysisIcon = createSvgIcon(
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1251 6.75302C8.8648 7.19087 5.54175 10.7907 5.54175 15.1666C5.54175 19.8381 9.32867 23.625 14.0001 23.625C18.376 23.625 21.9759 20.3019 22.4137 16.0416H14.0001C13.5168 16.0416 13.1251 15.6499 13.1251 15.1666V6.75302ZM3.79175 15.1666C3.79175 9.52874 8.36217 4.95831 14.0001 4.95831C14.4833 4.95831 14.8751 5.35006 14.8751 5.83331V14.2916H23.3334C23.8167 14.2916 24.2084 14.6834 24.2084 15.1666C24.2084 20.8046 19.638 25.375 14.0001 25.375C8.36217 25.375 3.79175 20.8046 3.79175 15.1666Z"
      fill="#8B8E93"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0834 5.45256V11.0833H23.7142C23.0573 8.30151 20.8652 6.10943 18.0834 5.45256ZM17.4978 3.5719C21.7215 4.09751 25.0692 7.44526 25.5948 11.669C25.6744 12.3084 25.1444 12.8333 24.5001 12.8333H16.9167C16.5946 12.8333 16.3334 12.5721 16.3334 12.25V4.66664C16.3334 4.02231 16.8584 3.49233 17.4978 3.5719Z"
      fill="#8B8E93"
    />
  </svg>
);

const AccountMetricsIcons = createSvgIcon(
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 9.62498C11.5838 9.62498 9.62504 11.5837 9.62504 14C9.62504 16.4162 11.5838 18.375 14 18.375C16.4163 18.375 18.375 16.4162 18.375 14C18.375 11.5837 16.4163 9.62498 14 9.62498Z"
      fill="#8B8E93"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 1.45831C14.4833 1.45831 14.875 1.85006 14.875 2.33331V3.82862C19.8149 4.24797 23.7521 8.18509 24.1714 13.125H25.6667C26.15 13.125 26.5417 13.5167 26.5417 14C26.5417 14.4832 26.15 14.875 25.6667 14.875H24.1714C23.7521 19.8149 19.8149 23.752 14.875 24.1713V25.6666C14.875 26.1499 14.4833 26.5416 14 26.5416C13.5168 26.5416 13.125 26.1499 13.125 25.6666V24.1713C8.18516 23.752 4.24803 19.8149 3.82868 14.875H2.33337C1.85012 14.875 1.45837 14.4832 1.45837 14C1.45837 13.5167 1.85012 13.125 2.33337 13.125H3.82868C4.24803 8.18509 8.18516 4.24797 13.125 3.82862V2.33331C13.125 1.85006 13.5168 1.45831 14 1.45831ZM5.54171 14C5.54171 18.6714 9.32863 22.4583 14 22.4583C18.6715 22.4583 22.4584 18.6714 22.4584 14C22.4584 9.32857 18.6715 5.54165 14 5.54165C9.32863 5.54165 5.54171 9.32857 5.54171 14Z"
      fill="#8B8E93"
    />
  </svg>
);

const PaymentIcon = createSvgIcon(
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0834 13.9999C18.0834 13.0334 18.8669 12.2499 19.8334 12.2499C20.7999 12.2499 21.5834 13.0334 21.5834 13.9999C21.5834 14.9664 20.7999 15.7499 19.8334 15.7499C18.8669 15.7499 18.0834 14.9664 18.0834 13.9999Z"
      fill="#8B8E93"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.8483 7.78626C23.0809 5.98298 21.3853 4.68667 19.3675 4.47434L18.607 4.39431C14.766 3.99011 10.8918 4.01677 7.05668 4.47377L6.55275 4.53382C4.60582 4.76583 3.0632 6.28694 2.80387 8.23042C2.29291 12.0598 2.29291 15.94 2.80387 19.7694C3.0632 21.7129 4.60583 23.234 6.55275 23.466L7.05668 23.5261C10.8918 23.9831 14.766 24.0097 18.607 23.6055L19.3675 23.5255C21.3853 23.3132 23.0809 22.0168 23.8483 20.2136C25.0608 19.8526 25.9862 18.8014 26.1381 17.5027C26.4103 15.1754 26.4103 12.8244 26.1381 10.4971C25.9862 9.19838 25.0608 8.14725 23.8483 7.78626ZM18.4239 6.1347C14.7126 5.74416 10.9693 5.76991 7.26375 6.21148L6.75982 6.27153C5.60621 6.409 4.69216 7.3103 4.5385 8.46187C4.04804 12.1376 4.04804 15.8622 4.5385 19.538C4.69216 20.6895 5.60621 21.5908 6.75982 21.7283L7.26375 21.7884C10.9693 22.2299 14.7126 22.2557 18.4239 21.8651L19.1844 21.7851C20.1767 21.6807 21.0547 21.1916 21.6631 20.4655C19.9036 20.5681 18.1207 20.5223 16.3821 20.328C14.9012 20.1624 13.7035 18.9963 13.5288 17.5027C13.2566 15.1754 13.2566 12.8244 13.5288 10.4971C13.7035 9.00351 14.9012 7.83738 16.3821 7.67187C18.1207 7.47755 19.9036 7.4317 21.6631 7.53431C21.0547 6.80827 20.1767 6.31915 19.1844 6.21473L18.4239 6.1347ZM22.4904 9.35039C22.4911 9.35487 22.4918 9.35935 22.4925 9.36383L22.4995 9.4092L22.7313 9.37321C22.8512 9.38507 22.9709 9.39768 23.0904 9.41104C23.7757 9.48763 24.3214 10.0291 24.3999 10.7004C24.6563 12.8926 24.6563 15.1072 24.3999 17.2994C24.3214 17.9707 23.7757 18.5122 23.0904 18.5888C22.9709 18.6021 22.8512 18.6148 22.7313 18.6266L22.4995 18.5906L22.4925 18.636C22.4918 18.6405 22.4911 18.645 22.4904 18.6494C20.532 18.8266 18.5235 18.8064 16.5765 18.5888C15.8912 18.5122 15.3455 17.9707 15.267 17.2994C15.0106 15.1072 15.0106 12.8926 15.267 10.7004C15.3455 10.0291 15.8912 9.48763 16.5765 9.41104C18.5235 9.19343 20.532 9.17322 22.4904 9.35039Z"
      fill="#8B8E93"
    />
  </svg>
);

const TrademateIcon = createSvgIcon(
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.61286 5.68851C9.54612 5.29064 9.216 4.98997 8.81364 4.96059C8.41128 4.93122 8.04099 5.18074 7.91716 5.5647L5.4789 13.1249H2.33325C1.85 13.1249 1.45825 13.5167 1.45825 13.9999C1.45825 14.4832 1.85 14.8749 2.33325 14.8749H6.11608C6.49586 14.8749 6.83227 14.63 6.94884 14.2685L8.48085 9.51827L10.6269 22.3114C10.6945 22.7145 11.0323 23.0172 11.4405 23.0402C11.8487 23.0633 12.2184 22.8006 12.331 22.4076L15.1654 12.5143L16.6586 17.7403C16.7548 18.0771 17.0426 18.3241 17.3901 18.368C17.7376 18.412 18.0778 18.2445 18.2549 17.9422L20.0519 14.8749H21.4124C21.7932 16.2216 23.0313 17.2083 24.4999 17.2083C26.2718 17.2083 27.7083 15.7719 27.7083 13.9999C27.7083 12.228 26.2718 10.7916 24.4999 10.7916C23.0313 10.7916 21.7932 11.7783 21.4124 13.1249H19.5504C19.2398 13.1249 18.9525 13.2896 18.7954 13.5576L17.7792 15.2923L16.0079 9.09289C15.9006 8.71737 15.5575 8.45841 15.1669 8.45827C14.7764 8.45813 14.433 8.71683 14.3254 9.09228L11.7133 18.2097L9.61286 5.68851ZM23.0416 13.9999C23.0416 13.1945 23.6945 12.5416 24.4999 12.5416C25.3053 12.5416 25.9583 13.1945 25.9583 13.9999C25.9583 14.8054 25.3053 15.4583 24.4999 15.4583C23.6945 15.4583 23.0416 14.8054 23.0416 13.9999Z"
      fill="#8B8E93"
    />
  </svg>
);

const TradingPlatformIcon = createSvgIcon(
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="path-1-outside-1_555_7326"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="21"
      fill="black"
    >
      <rect fill="white" width="21" height="21" />
      <path d="M17 3C17 3.55228 17.4477 4 18 4C18.5523 4 19 3.55228 19 3C19 2.44772 18.5523 2 18 2C17.4477 2 17 2.44772 17 3Z" />
    </mask>
    <path
      d="M13 2.75C13.4142 2.75 13.75 2.41421 13.75 2C13.75 1.58579 13.4142 1.25 13 1.25V2.75ZM19.75 8C19.75 7.58579 19.4142 7.25 19 7.25C18.5858 7.25 18.25 7.58579 18.25 8H19.75ZM3.06107 19.0451L2.62023 19.6518L2.62024 19.6518L3.06107 19.0451ZM1.95491 17.9389L2.56168 17.4981H2.56168L1.95491 17.9389ZM16.9389 19.0451L17.3798 19.6518H17.3798L16.9389 19.0451ZM18.0451 17.9389L18.6518 18.3798V18.3798L18.0451 17.9389ZM1.95491 4.06107L1.34815 3.62023L1.34815 3.62023L1.95491 4.06107ZM3.06107 2.95491L2.62023 2.34815L2.62023 2.34815L3.06107 2.95491ZM4.32665 13.5268C4.14423 13.8987 4.29782 14.3481 4.6697 14.5305C5.04158 14.7129 5.49093 14.5593 5.67335 14.1874L4.32665 13.5268ZM6.46033 10.8801L7.13368 11.2104L6.46033 10.8801ZM13.5397 11.1199L14.213 11.4502L13.5397 11.1199ZM15.6734 8.47316C15.8558 8.10127 15.7022 7.65192 15.3303 7.46951C14.9584 7.28709 14.5091 7.44068 14.3266 7.81256L15.6734 8.47316ZM10 11L9.30584 11.284L10 11ZM10 2.75H13V1.25H10V2.75ZM18.25 8V11H19.75V8H18.25ZM10 19.25C8.10843 19.25 6.74999 19.249 5.69804 19.135C4.66013 19.0225 4.00992 18.8074 3.50191 18.4383L2.62024 19.6518C3.42656 20.2377 4.37094 20.5 5.53648 20.6263C6.68798 20.751 8.14184 20.75 10 20.75V19.25ZM0.25 11C0.25 12.8582 0.248971 14.312 0.373728 15.4635C0.500006 16.6291 0.762324 17.5734 1.34815 18.3798L2.56168 17.4981C2.19259 16.9901 1.97745 16.3399 1.865 15.302C1.75103 14.25 1.75 12.8916 1.75 11H0.25ZM3.50191 18.4383C3.14111 18.1762 2.82382 17.8589 2.56168 17.4981L1.34815 18.3798C1.70281 18.8679 2.13209 19.2972 2.62023 19.6518L3.50191 18.4383ZM10 20.75C11.8582 20.75 13.312 20.751 14.4635 20.6263C15.6291 20.5 16.5734 20.2377 17.3798 19.6518L16.4981 18.4383C15.9901 18.8074 15.3399 19.0225 14.302 19.135C13.25 19.249 11.8916 19.25 10 19.25V20.75ZM18.25 11C18.25 12.8916 18.249 14.25 18.135 15.302C18.0225 16.3399 17.8074 16.9901 17.4383 17.4981L18.6518 18.3798C19.2377 17.5734 19.5 16.6291 19.6263 15.4635C19.751 14.312 19.75 12.8582 19.75 11H18.25ZM17.3798 19.6518C17.8679 19.2972 18.2972 18.8679 18.6518 18.3798L17.4383 17.4981C17.1762 17.8589 16.8589 18.1762 16.4981 18.4383L17.3798 19.6518ZM1.75 11C1.75 9.10843 1.75103 7.74999 1.865 6.69805C1.97745 5.66013 2.19259 5.00992 2.56168 4.50191L1.34815 3.62023C0.762324 4.42656 0.500006 5.37094 0.373728 6.53648C0.248971 7.68798 0.25 9.14184 0.25 11H1.75ZM10 1.25C8.14184 1.25 6.68798 1.24897 5.53648 1.37373C4.37094 1.50001 3.42656 1.76232 2.62023 2.34815L3.50191 3.56168C4.00992 3.19259 4.66013 2.97745 5.69805 2.865C6.74999 2.75103 8.10843 2.75 10 2.75V1.25ZM2.56168 4.50191C2.82382 4.14111 3.14111 3.82382 3.50191 3.56168L2.62023 2.34815C2.13209 2.70281 1.70281 3.13209 1.34815 3.62023L2.56168 4.50191ZM5.67335 14.1874L7.13368 11.2104L5.78698 10.5498L4.32665 13.5268L5.67335 14.1874ZM14.213 11.4502L15.6734 8.47316L14.3266 7.81256L12.8663 10.7896L14.213 11.4502ZM9.30584 11.284C10.185 13.433 13.1904 13.5348 14.213 11.4502L12.8663 10.7896C12.4137 11.7124 11.0833 11.6673 10.6942 10.716L9.30584 11.284ZM7.13368 11.2104C7.58632 10.2876 8.91668 10.3327 9.30584 11.284L10.6942 10.716C9.815 8.56698 6.80955 8.46517 5.78698 10.5498L7.13368 11.2104ZM15.5 3C15.5 4.38071 16.6193 5.5 18 5.5V2.5C18.2761 2.5 18.5 2.72386 18.5 3H15.5ZM18 5.5C19.3807 5.5 20.5 4.38071 20.5 3H17.5C17.5 2.72386 17.7239 2.5 18 2.5V5.5ZM20.5 3C20.5 1.61929 19.3807 0.5 18 0.5V3.5C17.7239 3.5 17.5 3.27614 17.5 3H20.5ZM18 0.5C16.6193 0.5 15.5 1.61929 15.5 3H18.5C18.5 3.27614 18.2761 3.5 18 3.5V0.5Z"
      fill="#8F8F8F"
      mask="url(#path-1-outside-1_555_7326)"
    />
  </svg>
);

const LeaderboardIcon = createSvgIcon(
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0001 7.29167C11.906 7.29167 10.2084 8.98925 10.2084 11.0833C10.2084 13.1774 11.906 14.875 14.0001 14.875C16.0942 14.875 17.7918 13.1774 17.7918 11.0833C17.7918 8.98925 16.0942 7.29167 14.0001 7.29167ZM11.9584 11.0833C11.9584 9.95575 12.8725 9.04167 14.0001 9.04167C15.1277 9.04167 16.0418 9.95575 16.0418 11.0833C16.0418 12.2109 15.1277 13.125 14.0001 13.125C12.8725 13.125 11.9584 12.2109 11.9584 11.0833Z"
      fill="#8B8E93"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.0001 2.625C9.32868 2.625 5.54175 6.41192 5.54175 11.0833C5.54175 12.7962 6.05087 14.3901 6.92602 15.722L3.90898 20.9477C3.7374 21.2448 3.75537 21.6149 3.95494 21.894C4.1545 22.1732 4.49882 22.3099 4.83553 22.2437L7.88504 21.6442L8.89063 24.5849C9.00167 24.9096 9.29224 25.1394 9.63378 25.1727C9.97531 25.2059 10.3048 25.0365 10.4763 24.7393L13.4861 19.5263C13.6561 19.5365 13.8275 19.5417 14.0001 19.5417C14.1727 19.5417 14.3441 19.5365 14.5141 19.5263L17.5238 24.7393C17.6956 25.0368 18.0255 25.2063 18.3674 25.1726C18.7092 25.139 18.9997 24.9084 19.1102 24.5831L20.1107 21.6365L23.1628 22.2434C23.4997 22.3103 23.8446 22.174 24.0447 21.8948C24.2448 21.6156 24.263 21.2451 24.0912 20.9477L21.0742 15.722C21.9493 14.3901 22.4584 12.7961 22.4584 11.0833C22.4584 6.41192 18.6715 2.625 14.0001 2.625ZM7.29175 11.0833C7.29175 7.37842 10.2952 4.375 14.0001 4.375C17.705 4.375 20.7084 7.37842 20.7084 11.0833C20.7084 14.7882 17.705 17.7917 14.0001 17.7917C10.2952 17.7917 7.29175 14.7882 7.29175 11.0833ZM11.6478 19.2103C10.3027 18.8216 9.09538 18.108 8.11647 17.1601L6.38723 20.1552L8.29703 19.7798C8.72642 19.6953 9.15215 19.9411 9.29374 20.3552L9.9235 22.1969L11.6478 19.2103ZM18.0739 22.192L16.3524 19.2103C17.6975 18.8216 18.9048 18.108 19.8837 17.1601L21.6102 20.1504L19.6994 19.7704C19.2688 19.6848 18.8414 19.9316 18.7002 20.3473L18.0739 22.192Z"
      fill="#8B8E93"
    />
  </svg>
);

const AffiliateMarketingIcon = createSvgIcon(
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.125 3.75351C5.86468 4.19136 2.54163 7.79117 2.54163 12.1671C2.54163 16.8385 6.32855 20.6255 11 20.6255C15.3759 20.6255 18.9757 17.3024 19.4136 13.0421H11C10.5167 13.0421 10.125 12.6504 10.125 12.1671V3.75351ZM0.791626 12.1671C0.791626 6.52923 5.36205 1.9588 11 1.9588C11.4832 1.9588 11.875 2.35055 11.875 2.8338V11.2921H20.3333C20.8165 11.2921 21.2083 11.6839 21.2083 12.1671C21.2083 17.805 16.6379 22.3755 11 22.3755C5.36205 22.3755 0.791626 17.805 0.791626 12.1671Z"
      fill="#8B8E93"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.0833 2.45305V8.0838H20.714C20.0572 5.30199 17.8651 3.10992 15.0833 2.45305ZM14.4976 0.572387C18.7213 1.098 22.0691 4.44575 22.5947 8.66945C22.6743 9.30885 22.1443 9.8338 21.5 9.8338H13.9166C13.5945 9.8338 13.3333 9.57263 13.3333 9.25047V1.66713C13.3333 1.0228 13.8582 0.492817 14.4976 0.572387Z"
      fill="#8B8E93"
    />
  </svg>
);

const ProfileIcon = createSvgIcon(
  <svg
    width="24"
    height="22"
    viewBox="0 0 19 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.0999 17.1674C18.1034 16.0134 17.8762 14.8702 17.4318 13.8051C16.9875 12.7403 16.3349 11.7751 15.5124 10.9659C15.4305 10.8824 15.3328 10.8159 15.2251 10.7704C15.117 10.7248 15.0009 10.7011 14.8836 10.7008C14.7662 10.7005 14.65 10.7235 14.5417 10.7686C14.4334 10.8136 14.3351 10.8798 14.2526 10.9632C14.1701 11.0466 14.105 11.1456 14.0611 11.2544C14.0173 11.3632 13.9955 11.4797 13.9972 11.597C13.9988 11.7143 14.0237 11.8302 14.0705 11.9377C14.1173 12.0451 14.1849 12.1421 14.2694 12.2231C14.9249 12.8683 15.445 13.6378 15.7991 14.4866C16.1533 15.3357 16.3344 16.2469 16.3317 17.1668V17.1671C16.3317 17.3605 16.1901 17.6017 15.8716 17.8618C15.5575 18.1183 15.0897 18.3777 14.4831 18.6095C13.2706 19.0726 11.5188 19.4194 9.37494 19.4194C7.23106 19.4194 5.47928 19.0724 4.26684 18.609C3.66017 18.3771 3.1924 18.1176 2.87832 17.8609C2.55988 17.6006 2.4182 17.3592 2.4182 17.1656L2.4182 17.1653C2.4156 16.2516 2.59425 15.3466 2.9438 14.5024C3.29329 13.6585 3.8067 12.8922 4.45429 12.2479C4.53792 12.1663 4.60453 12.0689 4.65028 11.9613C4.69609 11.8536 4.72007 11.7379 4.72081 11.6209C4.72155 11.5038 4.69904 11.3878 4.6546 11.2795C4.61015 11.1713 4.54465 11.0729 4.46188 10.9901C4.37912 10.9074 4.28075 10.8419 4.17248 10.7974C4.0642 10.753 3.94818 10.7305 3.83114 10.7312C3.7141 10.7319 3.59837 10.7559 3.49067 10.8017C3.38321 10.8474 3.28588 10.914 3.20428 10.9975C2.3918 11.8059 1.7477 12.7673 1.30927 13.8263C0.870754 14.8854 0.646687 16.021 0.650037 17.1673C0.650122 18.5069 1.81726 19.5106 3.45687 20.1749C5.10542 20.8428 7.27511 21.1875 9.37494 21.1875C11.4748 21.1875 13.6445 20.8428 15.293 20.1749C16.9326 19.5107 18.0997 18.507 18.0999 17.1674ZM18.0999 17.1674L17.9999 17.1671H18.0999C18.0999 17.1672 18.0999 17.1673 18.0999 17.1674Z"
      fill="#8b8e93"
      stroke="#8b8e93"
      stroke-width="0.2"
    />
    <path
      d="M9.37616 11.7803H9.37627C10.4816 11.7803 11.5621 11.4525 12.4811 10.8384C13.4002 10.2244 14.1165 9.35154 14.5394 8.33036C14.9624 7.30918 15.0731 6.18551 14.8575 5.10143C14.6418 4.01735 14.1096 3.02156 13.328 2.23998C12.5464 1.45841 11.5506 0.926147 10.4666 0.71051C9.38247 0.494874 8.2588 0.605546 7.23762 1.02853C6.21644 1.45152 5.34362 2.16782 4.72954 3.08686C4.11546 4.00589 3.7877 5.08639 3.7877 6.1917L3.7877 6.19182C3.78941 7.67345 4.37874 9.0939 5.42641 10.1416C6.47408 11.1892 7.89453 11.7786 9.37616 11.7803ZM9.37639 2.37129C10.132 2.37132 10.8705 2.59538 11.4988 3.01515C12.127 3.43494 12.6167 4.03161 12.9059 4.7297C13.195 5.42779 13.2707 6.19594 13.1233 6.93703C12.9759 7.67812 12.612 8.35885 12.0777 8.89314C11.5434 9.42744 10.8627 9.7913 10.1216 9.93871C9.38051 10.0861 8.61235 10.0105 7.91426 9.72131C7.21618 9.43215 6.61951 8.94248 6.19972 8.31421C5.77992 7.68595 5.55586 6.94731 5.55586 6.1917C5.55708 5.17885 5.95998 4.20782 6.67619 3.49162C7.39242 2.77539 8.36349 2.37249 9.37639 2.37129Z"
      fill="#8b8e93"
      stroke="#8b8e93"
      stroke-width="0.2"
    />
  </svg>
);

const sidebarMenu = [
  {
    label: "Dashboard",
    icon: <DashboardIcon />,
    url: "/dashboard",
  },
  {
    label: "Profile",
    icon: <ProfileIcon />,
    url: "/profile",
  },
  {
    label: "Achievements",
    icon: <AchievementIcon />,
    url: "/achievements",
  },
  {
    label: "Get Started",
    icon: <GetStartedIcon />,
    url: "/getting-started",
  },
  {
    label: "Account Analysis",
    icon: (
      <AccountAnalysisIcon
        viewBox="0 0 28 28"
        sx={{ width: "28px", height: "28px" }}
      />
    ),
    url: "/AccountAnalysis",
  },
  {
    label: "Account Metrics",
    icon: (
      <AccountMetricsIcons
        viewBox="0 0 28 28"
        sx={{ width: "28px", height: "28px" }}
      />
    ),
    url: "/AccountMetric",
  },
  {
    label: "Payment",
    icon: (
      <PaymentIcon viewBox="0 0 28 28" sx={{ width: "28px", height: "28px" }} />
    ),
    children: [
      {
        label: "Funding Evaluation",
        url: "/FundingEvaluation",
        child: [
          {
            Name: "FAQ",
            Link: "Https://help.alphacapitalgroup.uk",
          },
        ],
      },
      {
        label: "Payment History",
        url: "/PaymentHistory",
      },
    ],
  },
  {
    label: "Competition",
    icon: <LeaderboardIcon />,
    children: [
      {
        label: "Competition List",
        url: "/competitionlist",
      },
      {
        label: "Leaderboard List",
        url: "/leaderboardlist",
      },
    ],
  },
  {
    label: "Trademate",
    icon: <TrademateIcon />,
    url: "/Trademate",
  },
  {
    label: "Trading Platform",
    icon: <TradingPlatformIcon />,
    url: "/trading-platform",
  },
  {
    label: "Affiliate Marketing",
    icon: <AffiliateMarketingIcon />,
    url: "/affiliateMarketing",
  },
];

export default sidebarMenu;
